import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';
import toast from 'react-hot-toast';
import { useLoader } from '../HOC/LoaderProvider';

export interface HandlerOptions {
  errorToast?: string;
  successToast?: string;
  withoutToasts?: boolean;
}

const useAsyncGuiHandler = () => {
  const { t } = useTranslation();
  const { startLoader, stopLoader } = useLoader();
  function handleAsync(asyncFunction: Promise<void>, options?: HandlerOptions, withLoader = true) {
    handleMyPromise(asyncFunction, options, withLoader).catch(console.log);
  }

  async function handleMyPromise(promise: Promise<any>, options?: HandlerOptions, withLoader = true) {
    withLoader && startLoader();
    try {
      await promise;
      if (!options?.withoutToasts) toast.success(options?.successToast || t('toasts:success'));
    } catch (err) {
      if (!options?.withoutToasts) toast.error(options?.errorToast || t('toasts:error-network'));
      throw new Error(err as any);
    } finally {
      withLoader && stopLoader();
    }
  }

  return [handleAsync] as const;
};

export default useAsyncGuiHandler;
